// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"27cd74cb","498":"38ad41f7","703":"7cc4026d"}[chunkId] + ".chunk.js";
};